import { PlaceholdersId, TFComponent } from '@types';

import { FixedFooterPlaceholder } from './fixedFooter';

export const fixedFooter: TFComponent = {
	component: FixedFooterPlaceholder,
	id: PlaceholdersId.fixedFooter,
	name: 'fixedFooter',
};
